import ExternalCode from "!!raw-loader!./avatars/External.tsx";
import InternalCode from "!!raw-loader!./avatars/Internal.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import External from "./avatars/External";
import Internal from "./avatars/Internal";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Internal User (Host)", InternalCode, Internal),
		paneComponent("External User (Supplier)", ExternalCode, External),
	];

	return (
		<Pane
			components={components}
			imports='import {Avatar} from "designSystem/index";'
			muiApi="avatar"
			muiComponent="avatars"
			{...props}
		/>
	);
};